<template>
  <div class="template">
    <JorfZoomParams />
    <LoaderFullPage v-if="jorfsStore.loading" />
    <JorfZoomDatas v-else />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import JorfZoomParams from "@follaw-fr/components/jorfs/organisms/JorfZoomParams.vue";
import JorfZoomDatas from "@follaw-fr/components/jorfs/organisms/JorfZoomDatas.vue";
import { useJorfsStore } from "@follaw-fr/stores/jorfs";

const route = useRoute();
const jorfsStore = useJorfsStore();
jorfsStore.fetchOneJorf(route.params._id);
</script>
